import React from 'react'
import brandIcon from "./brandIcon.png";
import "./Recommender.css";

export default function NonEligibleCardV2({ partnerDetails }) {
  return (
    <div
      className="newBrandCard"
      style={{
        backgroundColor: "rgb(224,224,224)",
        border: "none",
        height: "100.5px",
        position:"relative",
        display:"flex",
        flexDirection:"row"
      }}
    >
      <div
        className="brandLogo"
        style={{
          marginRight: "20px",
          display:"flex",
          alignItems:"center",
          justifyContent:"center",
        }}
      >
        <img
          alt=""
          src={`https://onecode-asset.s3.ap-south-1.amazonaws.com/Brand_Logo_PNGs/${partnerDetails?.id}.png`}
          style={{
               width:"100%",
               opacity:"0.3",
               flex: "1",
              }}
        />
      </div>
      <div
        className="brandDetails"
        style={{}}
      >
        <div className="brandNameAndIcon" style={{}}>
          <div className="brandName"  style={{height:"45px",lineHeight:"13px"}}>
            <p style={{ fontWeight: "600", marginRight: "15px",color:"rgba(96,96,96)" }}>
            {partnerDetails?.title.length>20?partnerDetails?.title.substr(0,19)+"..":partnerDetails?.title}
            </p>
            <p
            style={{
              color: "#C10000",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Not Eligible
          </p>
          </div>
        </div>
      </div>
    </div>
  );
}
